import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=5da74d9a&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da74d9a",
  null
  
)

export default component.exports